import { AbstractControl, FormGroup } from '@angular/forms';
import { isObject } from '@ups/xplat/utils';
import { IDynamicModelOptions } from '../../models';

type ScopeControl = AbstractControl & { isLoading_dynamic?: boolean };

/**
 * `scopeQueryWhenFormControlIsSet`: scope the search to another control's value when no explicit
 * query is typed (ie, opening the dropdown the first time). Empty while that control is loading.
 */
export function dynamicScopeDefaultQuery(
  group: FormGroup | null | undefined,
  scope: IDynamicModelOptions['scopeQueryWhenFormControlIsSet']
): { query: string; paramName: string } {
  const name = scope?.formControlName;
  const control = name
    ? (group?.controls[name] as ScopeControl | undefined)
    : undefined;
  if (!scope || !control || control.isLoading_dynamic) {
    return { query: '', paramName: '' };
  }
  const value = control.value;
  const key = scope.matchTargetProperty;
  const query =
    isObject(value) && key ? (value as Record<string, string>)[key] : value;
  return { query, paramName: scope.queryParamName ?? '' };
}
